import React, { useState } from 'react';
import { ChevronDown, Phone } from 'lucide-react';
import { trackEvent } from '../context/SiteContext';
import './FAQ.css';

const faqData = [
  {
    category: "Allgemein",
    items: [
      { q: "Was ist die BD Event Location?", a: "Die BD Event Location ist eine exklusive Eventlocation in Woerth am Main im Rhein-Main-Gebiet. Wir bieten elegante Raeumlichkeiten fuer Hochzeiten, Firmenfeiern, Geburtstage und kulturelle Veranstaltungen mit bis zu 300 Gaesten." },
      { q: "Wo genau befindet sich die Location?", a: "Unsere Adresse ist Pfarrer-Adam-Haus-Strasse 6a, 63939 Woerth am Main. Wir liegen verkehrsguenstig im Rhein-Main-Gebiet, nur ca. 30 Minuten von Frankfurt, Aschaffenburg, Darmstadt und Hanau entfernt." },
      { q: "Fuer welche Events eignet sich die Location?", a: "Unsere Raeumlichkeiten sind ideal fuer Hochzeiten, Hochzeitsfeiern, Firmenfeiern, Weihnachtsfeiern, Geburtstage, Jubilaeen, Verlobungsfeiern, Kulturveranstaltungen und private Feste aller Art." },
      { q: "Wie viele Gaeste passen in die Location?", a: "Je nach Bestuhlung und Setup koennen wir bis zu 200-300 Gaeste bewirten. Ob intime Feier mit 50 Personen oder Grossevent - wir passen das Setup individuell an Ihre Wuensche an." },
      { q: "Kann ich die Location vorher besichtigen?", a: "Selbstverstaendlich! Wir bieten unverbindliche Besichtigungstermine an, bei denen wir Ihnen die Raeumlichkeiten zeigen und Ihre Fragen persoenlich beantworten. Kontaktieren Sie uns einfach per WhatsApp oder ueber unser Kontaktformular." },
      { q: "Wer ist mein Ansprechpartner fuer die Planung?", a: "Sie erhalten einen persoenlichen Ansprechpartner, der Sie von der ersten Anfrage bis zum Event-Tag begleitet. Wir kuemmern uns um eine reibungslose Planung und Koordination." },
    ]
  },
  {
    category: "Hochzeiten",
    items: [
      { q: "Ist die BD Event Location als Hochzeitslocation geeignet?", a: "Absolut! Wir sind eine der beliebtesten Hochzeitslocations im Rhein-Main-Gebiet. Unsere eleganten Raeume, der Aussenbereich fuer freie Trauungen und die individuelle Gestaltung machen Ihre Hochzeit unvergesslich." },
      { q: "Kann man bei euch eine freie Trauung durchfuehren?", a: "Ja, freie Trauungen sind bei uns moeglich - sowohl im Aussenbereich als auch im Innenbereich. Wir haben wunderschoene Fotospots und koennen die Zeremonie ganz nach Ihren Wuenschen gestalten." },
      { q: "Gibt es schoene Fotospots auf dem Gelaende?", a: "Definitiv! Unser Gelaende bietet mehrere attraktive Fotospots - von der eleganten Innenausstattung ueber die Terrasse bis zum Gartenbereich. Ihre Hochzeitsfotografen werden begeistert sein." },
      { q: "Kann man Hochzeit im Rhein-Main-Gebiet bei euch feiern?", a: "Genau dafuer sind wir bekannt! Als zentrale Hochzeitslocation im Rhein-Main-Gebiet sind wir optimal erreichbar von Frankfurt, Aschaffenburg, Darmstadt, Hanau, Offenbach, Wiesbaden und Mainz." },
    ]
  },
  {
    category: "Firmenfeiern & Business Events",
    items: [
      { q: "Eignet sich die Location fuer Firmenfeiern?", a: "Ja, wir sind ideal fuer Firmenevents aller Art: Weihnachtsfeiern, Sommerfeste, Teambuilding-Events, Produktpraesentationen, Jubilaeen und Firmenveranstaltungen. Moderne Technik und flexible Raumgestaltung inklusive." },
      { q: "Gibt es technische Ausstattung fuer Praesentationen?", a: "Unsere Location verfuegt ueber moderne Licht- und Soundtechnik, WLAN und die Moeglichkeit, Praesentationstechnik zu nutzen. Sprechen Sie uns an, wir richten alles nach Ihren Anforderungen ein." },
      { q: "Ist die Location aus Frankfurt gut erreichbar?", a: "Absolut. Von Frankfurt aus erreichen Sie uns in ca. 30-40 Minuten ueber die A3. Auch von Aschaffenburg, Darmstadt, Hanau und Offenbach ist die Anfahrt kurz und unkompliziert." },
    ]
  },
  {
    category: "Catering & Getraenke",
    items: [
      { q: "Gibt es Catering vor Ort?", a: "Wir arbeiten mit verschiedenen hochwertigen Caterern zusammen und bieten flexible Catering-Optionen. Von Buffet ueber Menue-Service bis zu Flying Buffet - alles ist moeglich. Sie koennen auch einen eigenen Caterer mitbringen." },
      { q: "Koennen wir einen eigenen Caterer mitbringen?", a: "Ja, Sie haben die freie Wahl beim Catering. Gerne empfehlen wir Ihnen auch bewährte Partner-Caterer, die unsere Raeumlichkeiten gut kennen." },
      { q: "Gibt es Getraenkepakete oder eine Bar?", a: "Wir bieten verschiedene Getraenkepauschalen an, die individuell auf Ihr Event zugeschnitten werden. Von der Softdrink-Flatrate bis zur Premium-Bar mit Cocktails ist alles moeglich." },
      { q: "Gibt es spezielle Optionen fuer verschiedene Kuechen?", a: "Absolut. Ob internationale Kueche, regionale Spezialitaeten, vegetarisch, vegan oder Halal - unsere Catering-Partner bieten vielfaeltige Optionen fuer jeden Geschmack und jede Kultur." },
    ]
  },
  {
    category: "Musik & Unterhaltung",
    items: [
      { q: "Darf man einen DJ oder Live-Musik mitbringen?", a: "Ja, DJs und Live-Bands sind herzlich willkommen! Wir haben eine Buehne, professionelle Soundanlage und Tanzflaeche. Gerne empfehlen wir Ihnen auch DJs aus unserem Netzwerk." },
      { q: "Gibt es eine Tanzflaeche?", a: "Ja, wir haben eine grosszuegige Tanzflaeche, die perfekt fuer Hochzeitstanz, Party oder Live-Auftritte geeignet ist." },
      { q: "Gibt es eine Sperrstunde?", a: "Die genauen Zeiten besprechen wir individuell. Grundsaetzlich sind wir flexibel und ermoeglichen auch laengere Feiern. Sprechen Sie uns einfach an, damit wir die optimale Loesung finden." },
      { q: "Ist eine Buehne vorhanden?", a: "Ja, wir verfuegen ueber eine Buehne, die fuer Live-Bands, DJs, Reden oder Auffuehrungen genutzt werden kann. Die Buehne ist mit professioneller Licht- und Tontechnik ausgestattet." },
    ]
  },
  {
    category: "Dekoration & Ausstattung",
    items: [
      { q: "Kann ich die Dekoration selbst gestalten?", a: "Ja, Sie koennen die Dekoration komplett selbst gestalten oder einen Dekorateur beauftragen. Wir unterstuetzen Sie gerne bei der Planung und beim Aufbau." },
      { q: "Wann kann mit dem Aufbau begonnen werden?", a: "In der Regel steht Ihnen die Location am Vortag oder am Morgen des Events fuer den Aufbau zur Verfuegung. Die genauen Zeiten stimmen wir individuell mit Ihnen ab." },
      { q: "Gibt es einen Aussenbereich oder eine Terrasse?", a: "Ja, wir haben einen schoenen Aussenbereich mit Terrasse, der sich perfekt fuer Empfaenge, freie Trauungen oder als Lounge-Bereich eignet." },
      { q: "Was passiert bei schlechtem Wetter?", a: "Kein Problem! Unser Innenbereich bietet genuegend Platz fuer alle Gaeste. Outdoor-Events koennen bei Bedarf kurzfristig nach innen verlegt werden." },
    ]
  },
  {
    category: "Praktische Informationen",
    items: [
      { q: "Gibt es ausreichend Parkplaetze?", a: "Ja, wir verfuegen ueber ausreichend Parkplaetze direkt vor der Location. Ihre Gaeste koennen bequem und kostenlos parken." },
      { q: "Gibt es Uebernachtungsmoeglichkeiten in der Naehe?", a: "In der Umgebung gibt es mehrere Hotels und Pensionen fuer jeden Geldbeutel. Wir senden Ihnen gerne eine Liste empfohlener Unterkuenfte in der Naehe." },
      { q: "Ist die Location barrierefrei zugaenglich?", a: "Ja, unsere Location ist barrierefrei zugaenglich. Rollstuhlfahrer und Gaeste mit eingeschraenkter Mobilitaet koennen alle wichtigen Bereiche problemlos erreichen." },
      { q: "Ist die Location kinderfreundlich?", a: "Auf jeden Fall! Kinder sind bei uns herzlich willkommen. Wir koennen auf Wunsch einen Kinderbereich einrichten und arbeiten mit erfahrenen Kinderbetreuern zusammen." },
      { q: "Gibt es WLAN in der Location?", a: "Ja, kostenfreies WLAN steht in der gesamten Location zur Verfuegung - fuer Ihre Gaeste, Fotografen und Dienstleister." },
      { q: "Gibt es einen Shuttle-Service?", a: "Wir vermitteln gerne Shuttle-Services oder Transfermoeglichkeiten fuer Ihre Gaeste, z.B. von Hotels oder Bahnhoefen. Sprechen Sie uns einfach an." },
    ]
  },
  {
    category: "Preise & Buchung",
    items: [
      { q: "Was kostet die Miete der Location?", a: "Die Kosten haengen von Eventtyp, Datum, Gaestezahl und gewuenschten Leistungen ab. Wir erstellen Ihnen gerne ein individuelles Angebot. Schicken Sie uns einfach eine Anfrage!" },
      { q: "Muss ich eine Anzahlung leisten?", a: "Ja, zur Reservierung Ihres Wunschtermins bitten wir um eine Anzahlung. Die genauen Konditionen besprechen wir transparent im persoenlichen Gespraech." },
      { q: "Wie laeuft eine Stornierung ab?", a: "Unsere Stornierungsbedingungen haengen vom Zeitpunkt ab. Je frueher Sie stornieren, desto flexibler sind die Konditionen. Alle Details besprechen wir bei der Buchung." },
      { q: "Bekomme ich ein individuelles Angebot?", a: "Ja, jedes Event ist einzigartig. Wir erstellen Ihnen ein massgeschneidertes Angebot basierend auf Ihren Wuenschen, dem Datum und der Gaestezahl. Kontaktieren Sie uns fuer ein unverbindliches Angebot." },
      { q: "Wie kann ich die Location buchen?", a: "Ganz einfach: Schicken Sie uns eine Anfrage ueber unser Kontaktformular oder per WhatsApp. Wir melden uns innerhalb von 24 Stunden, vereinbaren einen Besichtigungstermin und erstellen Ihnen ein persoenliches Angebot." },
    ]
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (idx) => {
    if (openIndex === idx) {
      setOpenIndex(null);
    } else {
      setOpenIndex(idx);
      trackEvent('faq_expand');
    }
  };

  const scrollToContact = () => {
    trackEvent('faq_cta_click');
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  let globalIdx = 0;

  return (
    <section className="faq-section section-padding" id="faq" data-testid="faq-section">
      <div className="container">
        <div className="faq-header">
          <h2 className="heading-1">Haeufig gestellte Fragen</h2>
          <p className="body-large space-top-md">Alles Wichtige rund um Ihre Veranstaltung bei der BD Event Location</p>
        </div>

        <div className="faq-grid space-top-xl">
          {faqData.map((cat) => (
            <div key={cat.category} className="faq-category">
              <h3 className="faq-category-title">{cat.category}</h3>
              {cat.items.map((item) => {
                const idx = globalIdx++;
                const isOpen = openIndex === idx;
                return (
                  <div key={idx} className={`faq-item ${isOpen ? 'faq-item-open' : ''}`} data-testid={`faq-item-${idx}`}>
                    <button
                      className="faq-question"
                      onClick={() => toggleFAQ(idx)}
                      aria-expanded={isOpen}
                      data-testid={`faq-toggle-${idx}`}
                    >
                      <span>{item.q}</span>
                      <ChevronDown size={20} className={`faq-chevron ${isOpen ? 'faq-chevron-open' : ''}`} />
                    </button>
                    {isOpen && (
                      <div className="faq-answer" data-testid={`faq-answer-${idx}`}>
                        <p>{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <div className="faq-cta space-top-xl">
          <p className="body-large">Ihre Frage war nicht dabei?</p>
          <button className="btn-primary" onClick={scrollToContact} data-testid="faq-cta-button">
            <Phone size={18} />
            Jetzt unverbindlich anfragen
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
